export default __webpack_public_path__ + "static/media/celebrate.498a661b69912bad38db4d60207f2492.svg";